// extracted by mini-css-extract-plugin
export var cancelButton = "_ns-5";
export var content = "_ns-3";
export var createButton = "_ns-6";
export var drawerContainer = "_ns-0";
export var footer = "_ns-2";
export var header = "_ns-1";
export var orderFormColumn = "_ns-4";